import ReportTypeBreadcrumb from './../../components/breadcrumbs/reportTypeBreadcrumb';
import { connect } from 'react-redux';

export default connect(state => ({
    projectKeyWord: state.companyReducer.company.settings.keyword.keyword1Singular,
    projectPluralKeyWord: state.companyReducer.company.settings.keyword.keyword1Plural,
    resourceKeyWord: state.companyReducer.company.settings.keyword.keyword2Singular,
    customerKeyWord: state.companyReducer.company.settings.keyword.keyword2Singular.keyword3Singular,
}))(ReportTypeBreadcrumb);
